import {
  requestForResetPasswordByEmail,
  changePasswordByToken,
  resetForgotPasswordForm,
} from '@actions/authentication';
import { selectTokenAndUserIdFromRoute } from '@selectors/router';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { ForgotPasswordPage } from './ForgotPasswordPage';

const mapStateToProps = (state) => {
  const { token, userId } = selectTokenAndUserIdFromRoute(state);
  const { authentication } = state;
  return {
    forgotPasswordFormRequestSuccess: authentication.forgotPasswordFormRequestSuccess,
    forgotPasswordLoading: authentication.forgotPasswordLoading,
    forgotPasswordFormChangeSuccess: authentication.forgotPasswordFormChangeSuccess,
    forgotPasswordFormRequestFail: authentication.forgotPasswordFormRequestFail,
    forgotPasswordFormChangeFail: authentication.forgotPasswordFormChangeFail,
    token,
    userId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      requestForResetPasswordByEmail,
      changePasswordByToken,
      resetForgotPasswordForm,
    },
    dispatch,
  ),
  goToLoginOnClick: () => dispatch(push('/login')),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./components/pages/ForgotPasswordPage/index.js